import { PROJECTESTIMATETYPE_SUCCESS, PROJECTESTIMATETYPE_FAIL } from '../actionTypes';

const initialState = {
    user: null,
    loading: false
};

const projectEstimateReducer = (state = initialState, action) => {
    switch (action.type) {
        case PROJECTESTIMATETYPE_SUCCESS:
            return {
                ...state,
                loading: true,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case PROJECTESTIMATETYPE_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default projectEstimateReducer;
